import React, { useState, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useLocation } from 'react-router-dom'
import http from './../../../services/Api'
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import Logo from './../../../assets/img/ares-logo.png'
import swal from 'sweetalert';

import './index.css'
import { RiLoader4Line } from 'react-icons/ri';
import { FiKey } from 'react-icons/fi';

function ResetPassword() {
  const { register, handleSubmit, errors, watch } = useForm();
  const [loading, setLoading] = useState(null);
  const location = useLocation();
  const history = useHistory();
  const password = useRef({});
  password.current = watch("password", "");

  const save = async data => {
    const { password, code } = data;
    let email = location.state;
    setLoading(true);
    try {
      await http.post('api/password/reset', {
        email,
        password,
        code
      });

      swal("Sua senha foi alterada com sucesso",
        {
          title: "Sucesso!",
          buttons: {
            login: {
              text: "Login",
              value: "login",
            },
          },
          icon: "success",
        })
        .then((value) => {
          if (value === 'login') {
            history.push('/login');
          }
        });
    } catch (e) {
      swal("Erro!", e.response.data.error, "error");
    }
    setLoading(false);
  }

  return (
    <div className="Register">
      <div className="content">
        <div className="left">
          <div className="container-img">
            <img src={Logo} alt="logo" />
          </div>
          <div className="copyright">
            Copyright © 2021 Synapse Brasil, Inc.
          </div>
        </div>

        <div className="right">
          <Form method="POST" onSubmit={handleSubmit(save)} className="Password-recover">
            <div className="text-center">
              <h1>Recuperação de senha</h1>
            </div>
            <div className="explanation">
              <p>Insira no campo abaixo o código de recuperação que foi encaminhado para o seu email e a nova senha.</p>
            </div>
            <br />
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroupPrepend">
                  <FiKey size="1.2em" />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control type="text" placeholder="Código de Recuperação" name="code" ref={register} required />
            </InputGroup>
            <br />
            <Form.Group as={Row} name="password" controlId="password">
              <Form.Label column sm="2" className="label-reset-password">
                Senha
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  name="password"
                  placeholder="Digite sua Senha"
                  type="password"
                  ref={register({
                    required: "Você deve escolher uma senha para alterar a antiga",
                    minLength: {
                      value: 8,
                      message: "A senha deve ter no mínimo 8 caracteres"
                    },
                    pattern: {
                      value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i,
                      message: "A senha deve conter ao menos um caractere maiúsculo e um caractere especial"
                    }
                  })} />
                <span className="form-error-register">
                  {errors.password && <p>{errors.password.message}</p>}
                </span>
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="confirmPassword">
              <Form.Label column sm="2" className="label-reset-password">
                Confirmar Senha
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  name="password_repeat"
                  type="password"
                  placeholder="Confirme sua Senha"
                  ref={register({
                    validate: value =>
                      value === password.current || "As senhas devem ser iguais"
                  })} />
                <span className="form-error-register">
                  {errors.password_repeat && <p>{errors.password_repeat.message}</p>}
                </span>
              </Col>
            </Form.Group>
            <br />
            <Row className="margin-button-group">
              <Col>
                <Button variant="default" type="button" onClick={() => {
                  history.push('/forgot-password');
                }}>
                  Voltar
                </Button>
              </Col>
              <Col>
                <Button variant="primary" type="submit">
                  {loading ? (<RiLoader4Line className="spin" />) : 'Alterar'}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default ResetPassword;